module.exports = __webpack_public_path__ + "static/media/Drawing.b28eb9cb.png";